export function hasRequestBoardCardMeta({ assignees, dueDate }) {
  return Boolean(dueDate) || assignees.length > 0
}
